module.exports = __webpack_public_path__ + "static/cupertino-3ee72a25487ec6ac4389e8a0774fe331.jpg";